import { createContext, useContext, useEffect, useState } from 'react'
import { CreatePayment, GetOrderPaymentData, CollectElavonPaymentStatus, GetActivePaymentSuppliersForSites, ChangeTaskStatusIfNeeded } from '../Services/PaymentService';
import { useConfig } from './ConfigProvider';
import { getActivePaymentSupplierName } from '../Helpers/PaymentHelper';
import { useAuth } from './AuthProvider';
import { toast } from 'react-toastify';

const PaymentContext = createContext()

export const usePayment = () => {
    return useContext(PaymentContext)
}

const PaymentProvider = ({ children }) => {
    const { api } = useConfig()
    const { authState } = useAuth()
    const [allPaymentSuppliers, setAllPaymentSuppliers] = useState([])
    const [activePaymentSuppliersForSites, setActivePaymentSuppliersForSites] = useState([])

    useEffect(() => {
        if (api && authState.user) {
            fetchAllPaymentSuppliers()
        } else {
            setAllPaymentSuppliers([])
        }
    }, [api, authState.user?.userId])

    useEffect(() => {
        const effectiveSiteId = authState.selectedCustomerData?.siteId ?? authState.initialSiteId
        if (allPaymentSuppliers.length > 0 && effectiveSiteId) {
            setActivePaymentSuppliersForSites(
                allPaymentSuppliers.filter(supplier => supplier.siteId === effectiveSiteId)
            )
        } else {
            setActivePaymentSuppliersForSites([])
        }
    }, [allPaymentSuppliers, authState.selectedCustomerData?.siteId, authState.initialSiteId])

    const fetchAllPaymentSuppliers = async () => {
        try {
            const res = await GetActivePaymentSuppliersForSites(api)
            setAllPaymentSuppliers(res.data)
        } catch (error) {
            setAllPaymentSuppliers([])
            console.log(error)
        }
    }

    const paymentCreate = async (payment) => {
        try {
            const res = await CreatePayment(api, payment, 'Elavon')
            if (res) {
                return res.data;
            }
            else {
                toast.error('Błąd w trakcie generowania linku do płatności!')
                console.log("Nie ma odpowiedzi")
                return "";
            }
        } catch (e) {
            toast.error('Błąd w trakcie generowania linku do płatności!')
            console.error(e)
            return "";
        }
    }

    const handleGetPaymentData = async (paymentGuid) => {
        try {
            const result = await GetOrderPaymentData(api, paymentGuid)
            return result.data
        } catch (error) {
            console.log(error)
            return null
        }
    }

    const handleCollectElavonPaymentStatus = async (paymentId) => {
        try {
            const res = await CollectElavonPaymentStatus(api, paymentId, authState.siteId)
            return res.data
        } catch (error) {
            console.log(error)
            return 99
        }
    }

    /**
     * DK : Funkcja zmienia status taska aby ponownie spróbował pobrac odpowiedz z bramki płatności, jeżeli status to 99
     * @param {*} remoteId Id zewnetrzne operatora płatności
     * @returns czy dokonano aktualizacji na wpisie
     */
    const handleChangeTaskStatusIfNeeded = async (remoteId) => {
        try {
            const res = await ChangeTaskStatusIfNeeded(api, remoteId)
            return res.data
        } catch (e) {
            console.log(e)
            return false
        }
    }

    return (
        <PaymentContext.Provider value={{
            paymentCreate,
            handleGetPaymentData,
            handleCollectElavonPaymentStatus,
            handleChangeTaskStatusIfNeeded,
            activePaymentSuppliersForSites,
        }}>
            {children}
        </PaymentContext.Provider>
    )
}

export default PaymentProvider
